import { type RecurrenceSettingsState, type UpdateRecurrenceEndAction } from '../../../../types'
import { computeDefaultRecurrenceEndByRecurrenceType } from './computeDefaultRecurrenceEndByRecurrenceType'

export function updateRecurrenceEnd(
  state: RecurrenceSettingsState,
  payload: UpdateRecurrenceEndAction['recurrenceEnd'],
): RecurrenceSettingsState {
  return {
    ...state,
    value: {
      ...state.value,
      recurrenceEnd: computeRecurrenceEnd(state, payload),
    },
  }
}

function computeRecurrenceEnd(
  state: RecurrenceSettingsState,
  payload: UpdateRecurrenceEndAction['recurrenceEnd'],
): RecurrenceSettingsState['value']['recurrenceEnd'] {
  switch (payload.endType) {
    case 'NEVER': {
      return {
        endType: 'NEVER',
      }
    }

    case 'ON_DATE': {
      const endDate =
        payload.endDate ??
        computeDefaultRecurrenceEndByRecurrenceType(
          state,
          state.value.recurrencePeriod.recurrenceType,
        )
      return {
        endType: 'ON_DATE',
        endDate,
      }
    }

    case 'AFTER_NUMBER': {
      return {
        endType: 'AFTER_NUMBER',
        numOfRecurrencesRequired: payload.numOfRecurrencesRequired ?? 12,
      }
    }
  }
}
